var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.083 3.81641H18.9844V19.1973H20.083C21.4157 19.1973 22.5 18.113 22.5 16.7803V6.2334C22.5 4.90067 21.4157 3.81641 20.083 3.81641Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.2334V16.7803C0 18.113 1.08426 19.1973 2.41699 19.1973H3.51562V3.81641H2.41699C1.08426 3.81641 0 4.90067 0 6.2334Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4268 2.27832C15.4268 1.18791 14.5396 0.300781 13.4492 0.300781H9.05469C7.96427 0.300781 7.07715 1.18791 7.07715 2.27832V3.81641H4.83594V19.1973H17.668V3.81641H15.4268V2.27832ZM12.6486 12.9566L9.604 14.7144C9.28874 14.8964 8.88559 14.7884 8.70356 14.4731L6.28657 10.2868C6.18282 10.1071 6.16972 9.88908 6.25124 9.69827L6.95656 8.04711C6.66964 7.6549 6.28455 6.97238 6.29189 6.13971C6.29193 6.13641 6.29198 6.13316 6.29207 6.12982C6.30586 5.54807 6.48762 5.01655 6.84767 4.50494C7.01567 4.26623 7.22204 4.03662 7.46497 3.81636H8.39551V2.27832C8.39551 1.91485 8.69122 1.61914 9.05469 1.61914H13.4492C13.8127 1.61914 14.1084 1.91485 14.1084 2.27832V3.81641H9.90138C8.84265 4.30873 7.6389 5.09917 7.61016 6.15632C7.60761 6.65804 7.88179 7.09174 8.05216 7.31256L9.98092 7.54495C10.1869 7.56978 10.3692 7.69014 10.4729 7.86979L12.8899 12.0561C13.0719 12.3714 12.9639 12.7746 12.6486 12.9566ZM16.3057 8.43066C16.3057 9.52108 15.4185 10.4082 14.3281 10.4082C13.2377 10.4082 12.3506 9.52108 12.3506 8.43066C12.3506 7.34025 13.2377 6.45312 14.3281 6.45312C15.4185 6.45312 16.3057 7.34025 16.3057 8.43066Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12932 8.65039L7.58984 9.91325L9.51245 13.2433L11.4154 12.1447L9.49276 8.81461L8.12932 8.65039Z",
    fill: "#0098C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3271 9.08984C14.6912 9.08984 14.9863 8.79472 14.9863 8.43066C14.9863 8.06661 14.6912 7.77148 14.3271 7.77148C13.9631 7.77148 13.668 8.06661 13.668 8.43066C13.668 8.79472 13.9631 9.08984 14.3271 9.08984Z",
    fill: "#0098C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(0 -1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripType);
export default __webpack_public_path__ + "static/media/tripType.ec6d70f5ef98ba3ba28e6cfe9f65e0da.svg";
export { ForwardRef as ReactComponent };